import RegistrationLogin from './ui';

export default RegistrationLogin;